import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";

import Home from "./Home";
import Attend from "./Attend";
import Organisers from "./Organisers";
import Schedule from "./Schedule";
import Nav from "./Nav";
import Footer from "./Footer";

import { Box } from "@material-ui/core";

function App() {
  return (
    <Box
      sx={{
        textAlign: "center",
        backgroundColor: "#f6e4dd",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{ minHeight: "100vh", marginBottom: "-32px" }}
        className={"wrap"}
      >
        <Router basename="/time_net">
          <Nav />
          <Switch>
            <Route path="/" exact component={() => <Home />} />
            <Route path="/organisers" exact component={() => <Organisers />} />
            <Route path="/attend" exact component={() => <Attend />} />
            <Route path="/schedule" exact component={() => <Schedule />} />
          </Switch>
        </Router>
      </Box>
      <Footer />
    </Box>
  );
}

export default App;
